export const getAPIUrl = () => {
  const domain = window.location.hostname;
  let apiUrl = 'https://lastpass.com';

  if (domain.includes('review.lastpass.com')) {
    apiUrl = 'https://rc.lastpass.dev';
  }

  if (domain.includes('dev-cm.') || domain.includes('localhost') || domain.includes('dev-cd.')) {
    apiUrl = 'https://karol.dev.lastpass.com';
  }

  return apiUrl;
};
